<template>
  <div class="verify-page">
    <!-- 顶部白栏 -->
    <div class="top-bar">
      <div class="back-btn" @click="goHome">
        <svg viewBox="0 0 24 24" class="back-icon"><path d="M15 18 L9 12 L15 6" fill="none" stroke="#323233" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
      </div>
      <div class="top-title">江苏智慧人社</div>
    </div>

    <!-- 灰底主体 + 验证卡片 -->
    <div class="gray-body">
      <div class="verify-card" :class="{ shake: shaking }">
        <div class="card-head">
          <span class="card-title">安全验证</span>
          <span class="close-btn" @click="goHome">&times;</span>
        </div>

        <div class="tip-row">
          <span>请依次点击：</span>
          <span v-for="(t, i) in targets" :key="i" class="target">{{ labelOf(t) }}</span>
        </div>

        <!-- 点选区域：背景图上随机散布可点元素（背景色调每局随机） -->
        <div class="captcha-img">
          <img :src="bgImg" class="bg" :style="{ filter: bgFilter }" draggable="false" alt="" />
          <div
            v-for="it in items"
            :key="it.key"
            class="cap-item"
            :class="{ selected: orderOf(it.key) > 0 }"
            :style="{ left: it.x + '%', top: it.y + '%', transform: 'translate(-50%,-50%) rotate(' + it.rotate + 'deg)' }"
            @click="tapItem(it)"
          >
            <span v-if="it.type === 'text'" class="cap-text">{{ it.key }}</span>
            <svg v-else viewBox="0 0 24 24" class="cap-svg"><path :d="svgPaths[it.key]" fill="none" stroke="#323233" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
            <span v-if="orderOf(it.key) > 0" class="order-badge">{{ orderOf(it.key) }}</span>
          </div>
          <span class="ai-mark">AI</span>
        </div>

        <div class="err-tip" v-if="errorMsg">{{ errorMsg }}</div>

        <div class="btn-row">
          <div class="icon-op" @click="flashError('请按上方提示顺序点击图片中的目标')">
            <svg viewBox="0 0 24 24" class="op-icon"><circle cx="12" cy="12" r="9" fill="none" stroke="#969799" stroke-width="1.8"/><path d="M9.6 9.2 a2.4 2.4 0 1 1 3.4 2.2 c-.7.3-1 .8-1 1.6" fill="none" stroke="#969799" stroke-width="1.8" stroke-linecap="round"/><circle cx="12" cy="16.4" r="0.9" fill="#969799"/></svg>
          </div>
          <div class="icon-op" @click="setup">
            <svg viewBox="0 0 24 24" class="op-icon"><path d="M20 12 a8 8 0 1 1-2.4-5.7" fill="none" stroke="#969799" stroke-width="1.8" stroke-linecap="round"/><path d="M20 3.5 v3.2 h-3.2" fill="none" stroke="#969799" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>
          </div>
          <button class="op-btn primary" @click="confirm">确定</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import bgImg from '../assets/verify-bg.jpg'

// 可点元素库：9 个数字 + 9 个图标（每局随机抽 6 个）
const ELEMENTS = [
  { key: '1', type: 'text' },
  { key: '2', type: 'text' },
  { key: '3', type: 'text' },
  { key: '4', type: 'text' },
  { key: '5', type: 'text' },
  { key: '6', type: 'text' },
  { key: '7', type: 'text' },
  { key: '8', type: 'text' },
  { key: '9', type: 'text' },
  { key: 'building', type: 'svg' },
  { key: 'mountain', type: 'svg' },
  { key: 'star', type: 'svg' },
  { key: 'heart', type: 'svg' },
  { key: 'tree', type: 'svg' },
  { key: 'cloud', type: 'svg' },
  { key: 'sun', type: 'svg' },
  { key: 'moon', type: 'svg' },
  { key: 'fish', type: 'svg' }
]
// 图标在目标序列中的中文读法
const LABELS = {
  building: '建筑', mountain: '山', star: '星星', heart: '爱心',
  tree: '树', cloud: '云朵', sun: '太阳', moon: '月亮', fish: '鱼'
}
// 候选摆位（百分比，3×3 分散不重叠）
const POSITIONS = [
  { x: 15, y: 20 }, { x: 45, y: 14 }, { x: 76, y: 20 },
  { x: 20, y: 48 }, { x: 55, y: 44 }, { x: 83, y: 50 },
  { x: 14, y: 78 }, { x: 47, y: 76 }, { x: 78, y: 80 }
]
const SVG_PATHS = {
  building: 'M3 21h18 M5 21v-8h14v8 M7 13V9h10v4 M9 9V5h6v4 M12 5V2',
  mountain: 'M3 20 L9 7 l4 7 3-4 5 10 Z',
  star: 'M12 3 l2.7 5.8 6.3.7 -4.7 4.3 1.3 6.2 -5.6-3.2 -5.6 3.2 1.3-6.2 L3 9.5 l6.3-.7 Z',
  heart: 'M12 20 C12 20 3.5 14.5 3.5 8.8 C3.5 6 5.7 4 8.2 4 C9.9 4 11.3 5 12 6.4 C12.7 5 14.1 4 15.8 4 C18.3 4 20.5 6 20.5 8.8 C20.5 14.5 12 20 12 20 Z',
  tree: 'M12 2.5 L7.2 9.5 H10 L6.5 14.5 H10.5 V20 h3 v-5.5 H17.5 L14 9.5 h2.8 Z',
  cloud: 'M7.5 18.5 a4.2 4.2 0 0 1-.5-8.37 A5.3 5.3 0 0 1 17 7.4 a3.8 3.8 0 0 1 0 11.1 Z',
  sun: 'M12 8.2 a3.8 3.8 0 1 0 0 7.6 a3.8 3.8 0 0 0 0-7.6 Z M12 2.5 v2.2 M12 19.3 v2.2 M2.5 12 h2.2 M19.3 12 h2.2 M5.2 5.2 l1.6 1.6 M17.2 17.2 l1.6 1.6 M18.8 5.2 l-1.6 1.6 M6.8 17.2 l-1.6 1.6',
  moon: 'M20 13.5 A8 8 0 1 1 10.5 4 a6.6 6.6 0 0 0 9.5 9.5 Z',
  fish: 'M3 12 c3.8-4.8 10.2-4.8 13.2 0 c-3 4.8-9.4 4.8-13.2 0 Z M16.2 12 l4.3-3.6 v7.2 Z M7.6 10.6 h.05'
}
// 同一背景图的多种色调风格（CSS filter），每局随机切换
const BG_FILTERS = [
  'none',
  'hue-rotate(115deg) saturate(1.15)',
  'hue-rotate(250deg) saturate(1.2) brightness(1.03)',
  'sepia(.38) saturate(1.45) hue-rotate(-18deg)',
  'hue-rotate(185deg) saturate(.92) brightness(1.06) contrast(1.05)'
]
// 扫码托管环境允许落地的页面白名单（与路由守卫 SHARE_PATHS 保持一致）
const ALLOWED_REDIRECTS = ['/jiangsu-pension-insured', '/jiangsu-social-insured']
const FALLBACK_REDIRECT = '/jiangsu-pension-insured'

function shuffle(arr) {
  for (let i = arr.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1))
    const t = arr[i]
    arr[i] = arr[j]
    arr[j] = t
  }
  return arr
}

export default {
  name: 'ScanVerify',
  data() {
    return {
      bgImg,
      svgPaths: SVG_PATHS,
      items: [],      // 本次散布的元素（6个）
      targets: [],    // 目标序列（3个 key，按点击顺序）
      clicked: [],    // 用户已点序列
      bgFilter: 'none', // 本局背景色调风格
      errorMsg: '',
      shaking: false
    }
  },
  created() {
    this.setup()
  },
  computed: {
    // 仅允许跳回两个权益记录单页；缺失或被篡改时走兜底页，杜绝跳出白名单
    safeRedirect() {
      const r = String(this.$route.query.redirect || '')
      const path = r.split('?')[0]
      return ALLOWED_REDIRECTS.indexOf(path) !== -1 ? r : FALLBACK_REDIRECT
    },
    isShareHost() {
      return location.protocol.indexOf('http') === 0 &&
        location.hostname !== 'localhost' &&
        location.hostname !== '127.0.0.1'
    }
  },
  methods: {
    // 生成/重置一局：随机抽 6 个元素摆位（±30°旋转），随机抽 3 个作为目标序列，背景色调随机
    setup() {
      const els = shuffle(ELEMENTS.slice()).slice(0, 6)
      const pos = shuffle(POSITIONS.slice()).slice(0, els.length)
      this.items = els.map((e, i) => ({
        key: e.key,
        type: e.type,
        x: pos[i].x,
        y: pos[i].y,
        rotate: Math.round(Math.random() * 60 - 30)
      }))
      this.targets = shuffle(this.items.slice()).slice(0, 3).map(it => it.key)
      this.clicked = []
      this.bgFilter = BG_FILTERS[Math.floor(Math.random() * BG_FILTERS.length)]
      this.errorMsg = ''
    },
    labelOf(key) {
      return LABELS[key] || key
    },
    // 已选序号（1 起），未选返回 0
    orderOf(key) {
      const i = this.clicked.indexOf(key)
      return i === -1 ? 0 : i + 1
    },
    tapItem(it) {
      const i = this.clicked.indexOf(it.key)
      if (i !== -1) {
        // 再次点击取消选择
        this.clicked.splice(i, 1)
        return
      }
      if (this.clicked.length >= 3) return
      this.clicked.push(it.key)
      this.errorMsg = ''
    },
    flashError(msg) {
      this.errorMsg = msg
    },
    confirm() {
      if (this.clicked.length < 3) {
        this.flashError('请按顺序点击 3 个目标')
        return
      }
      const ok = this.targets.every((t, i) => this.clicked[i] === t)
      if (ok) {
        // 验证通过：带回 v 时间戳凭证跳回白名单内的目标页（30 分钟内守卫放行）
        const redirect = this.safeRedirect
        const sep = redirect.indexOf('?') === -1 ? '?' : '&'
        this.$router.replace(redirect + sep + 'v=' + Date.now())
      } else {
        this.flashError('验证失败，请重试')
        this.shaking = true
        setTimeout(() => {
          this.shaking = false
          this.setup()
        }, 600)
      }
    },
    goHome() {
      // 托管环境没有可去的其他页面：关闭/返回仅重置验证，留在验证页
      if (this.isShareHost) {
        this.setup()
        return
      }
      this.$router.replace('/home')
    }
  }
}
</script>

<style scoped>
.verify-page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: #7a7a7a;
}

/* 顶部白栏 */
.top-bar {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  height: calc(112 * var(--w));
  background: #fff;
  border-bottom: 1px solid #ebebeb;
  flex-shrink: 0;
}
.back-btn {
  position: absolute;
  left: calc(24 * var(--w));
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  width: calc(48 * var(--w));
  height: calc(48 * var(--w));
  cursor: pointer;
}
.back-icon {
  width: calc(36 * var(--w));
  height: calc(36 * var(--w));
}
.top-title {
  font-size: calc(46 * var(--w));
  font-weight: 500;
  color: #323233;
}

/* 灰底主体：卡片上下居中 */
.gray-body {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: calc(40 * var(--w)) calc(40 * var(--w));
  box-sizing: border-box;
}

/* 验证卡片 */
.verify-card {
  width: 100%;
  background: #fff;
  border-radius: calc(16 * var(--w));
  padding: calc(32 * var(--w)) calc(32 * var(--w)) calc(28 * var(--w));
  box-sizing: border-box;
  box-shadow: 0 calc(6 * var(--w)) calc(24 * var(--w)) rgba(0, 0, 0, 0.18);
}
.verify-card.shake {
  animation: shake 0.5s;
}
@keyframes shake {
  0%, 100% { transform: translateX(0); }
  20% { transform: translateX(calc(-16 * var(--w))); }
  40% { transform: translateX(calc(16 * var(--w))); }
  60% { transform: translateX(calc(-10 * var(--w))); }
  80% { transform: translateX(calc(10 * var(--w))); }
}

.card-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.card-title {
  font-size: calc(40 * var(--w));
  font-weight: 600;
  color: #323233;
}
.close-btn {
  font-size: calc(48 * var(--w));
  color: #969799;
  line-height: 1;
  cursor: pointer;
  padding: 0 calc(8 * var(--w));
}

.tip-row {
  margin-top: calc(28 * var(--w));
  font-size: calc(30 * var(--w));
  color: #323233;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.target {
  color: #2E8CF6;
  font-weight: 600;
  margin: 0 calc(12 * var(--w));
}

/* 点选区域 */
.captcha-img {
  position: relative;
  margin-top: calc(24 * var(--w));
  width: 100%;
  height: calc(560 * var(--w));
  border-radius: calc(12 * var(--w));
  overflow: hidden;
  user-select: none;
}
.captcha-img .bg {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.cap-item {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  width: calc(96 * var(--w));
  height: calc(96 * var(--w));
  cursor: pointer;
}
.cap-text {
  font-size: calc(56 * var(--w));
  font-weight: 700;
  color: #323233;
  text-shadow: 0 0 calc(8 * var(--w)) #fff, 0 0 calc(8 * var(--w)) #fff, 0 calc(2 * var(--w)) calc(4 * var(--w)) rgba(0, 0, 0, 0.25);
}
.cap-svg {
  width: calc(64 * var(--w));
  height: calc(64 * var(--w));
  filter: drop-shadow(0 0 calc(6 * var(--w)) #fff) drop-shadow(0 calc(2 * var(--w)) calc(3 * var(--w)) rgba(0, 0, 0, 0.25));
}
.cap-item.selected .cap-text,
.cap-item.selected .cap-svg {
  opacity: 0.55;
}
.order-badge {
  position: absolute;
  top: 0;
  right: 0;
  min-width: calc(36 * var(--w));
  height: calc(36 * var(--w));
  border-radius: 50%;
  background: #2E8CF6;
  color: #fff;
  font-size: calc(26 * var(--w));
  display: flex;
  align-items: center;
  justify-content: center;
}
.ai-mark {
  position: absolute;
  right: calc(12 * var(--w));
  bottom: calc(8 * var(--w));
  font-size: calc(24 * var(--w));
  color: rgba(255, 255, 255, 0.85);
  text-shadow: 0 calc(1 * var(--w)) calc(2 * var(--w)) rgba(0, 0, 0, 0.4);
}

.err-tip {
  margin-top: calc(20 * var(--w));
  font-size: calc(28 * var(--w));
  color: #ee0a24;
  text-align: center;
}

/* 底部按钮行：左侧帮助/刷新符号，右侧确定 */
.btn-row {
  margin-top: calc(28 * var(--w));
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.icon-op {
  display: flex;
  align-items: center;
  justify-content: center;
  width: calc(64 * var(--w));
  height: calc(64 * var(--w));
  margin-right: calc(40 * var(--w));
  cursor: pointer;
}
.op-icon {
  width: calc(52 * var(--w));
  height: calc(52 * var(--w));
}
.op-btn {
  border: 1px solid #dcdee0;
  background: #fff;
  color: #323233;
  font-size: calc(30 * var(--w));
  border-radius: calc(10 * var(--w));
  padding: calc(16 * var(--w)) calc(40 * var(--w));
  cursor: pointer;
}
.op-btn.primary {
  margin-left: auto;
  background: #2E8CF6;
  border-color: #2E8CF6;
  color: #fff;
  font-size: calc(32 * var(--w));
  border-radius: calc(8 * var(--w));
  padding: calc(14 * var(--w)) calc(64 * var(--w));
}
.op-btn:active,
.icon-op:active {
  opacity: 0.6;
}
</style>



// WEBPACK FOOTER //
// src/pages/ScanVerify.vue